import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard-container',
  templateUrl: './app-dashboard-container.component.html',
  styleUrls: ['./app-dashboard-container.component.scss'],
  standalone: false,
})
export class AppDashboardContainerComponent {
  public constructor() {}
}
